import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { authorize } from "../../services/auth/reducer";

import { getOnboardingStatsRequest } from "../../services/stats/actions";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";

import Logo from "../../resources/logo.png";
import Colors from "../../constants/Colors";

import i18n from "../../i18n";
import CategoryProgressBar from "./CategoryProgressBar";

const styles = theme => ({
  main: {
    // backgroundColor: Colors.veryLightGrey,
    flex: 1,
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // paddingTop: 20,
    paddingBottom: 100
  },
  paper: {
    width: "100%",
    // marginTop: theme.spacing.unit * 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 3}px`
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main
  },
  logo: {
    width: "40%",
    marginBottom: 15
    // height: 50,
    // width: 120
  },
  form: {
    width: "100%", // Fix IE11 issue.
    marginTop: theme.spacing.unit
  },
  submit: {
    marginTop: theme.spacing.unit * 3
  },
  title: {
    marginBottom: 15
  },
  stats: {
    marginBottom: 15,
    width: "100%",
    flexDirection: "row",
    justifyContent: "center",
    display: "flex"
  },
  bar: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  bigCategories: {
    marginRight: 15,
    flexDirection: "column",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-around"
  },
  border: {
    marginRight: 15,
    boxShadow: "0px 0px 4px 1px #D8D8D8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Colors.lightBlue,
    borderRadius: 8
  },
  verticalText: {
    color: "#fff",
    fontWeight: "bold",
    transform: "rotate(-90deg)"
  }
});

const getCategoryTitle = category => {
  switch (category) {
    case "motivation":
      return i18n.t("motivation-title");
    case "capitalization":
      return i18n.t("capitalization-title");
    case "debriefing":
      return i18n.t("debriefing-title");
    case "visualization":
      return i18n.t("visualization-title");
    case "briefing":
      return i18n.t("briefing-title");
    case "preparation":
      return i18n.t("preparation-title");
    case "training":
      return i18n.t("training-title");
    case "integration":
      return i18n.t("integration-title");
    case "recruiting":
      return i18n.t("recruiting-title");
    case "leadership":
      return i18n.t("leadership");
    case "teamCohesion":
      return i18n.t("teamCohesion");
    case "confidence":
      return i18n.t("confidence");
    case "stress":
      return i18n.t("stress-title");
    case "publicSpeaking":
      return i18n.t("publicSpeaking");
    case "position":
      return i18n.t("position-title");
    default:
      break;
  }
};

class Login extends PureComponent {
  componentDidMount() {
    this.refresh();
  }

  refresh = () => {
    this.props.getOnboardingStatsRequest(this.props.clientId);
  };

  renderStats = stats => {
    const ranking = [];
    const { numberOfFeedbacks } = stats;
    // For displaying in the good order
    const sortedStatsNames = [
      "recruiting",
      "integration",
      "position",
      "training",
      "preparation",
      "briefing",
      "visualization",
      "debriefing",
      "capitalization",
      "teamCohesion",
      "motivation",
      "leadership",
      "confidence",
      "stress",
      "publicSpeaking"
    ];

    sortedStatsNames.forEach(stat => {
      if (
        stat !== "numberOfFeedbacks" &&
        stat !== "stress" &&
        stat !== "confidence" &&
        stat !== "publicSpeaking"
      ) {
        ranking.push([stat, (stats[stat] / numberOfFeedbacks).toFixed(1)]);
      }
    });

    return ranking.map((el, i) => {
      return (
        <CategoryProgressBar
          key={i}
          title={getCategoryTitle(el[0])}
          progress={el[1] * 10}
        />
      );
    });
  };

  render() {
    const { classes, onboardingStats } = this.props;

    return (
      <div className={classes.main}>
        <div className={classes.paper}>
          {/* <Avatar className={classes.avatar} src={Logo} alt="Pulse Logo" /> */}
          <Typography variant="h5" className={classes.title}>
            {`Baromètre de l'entreprise (${onboardingStats.numberOfFeedbacks})`}
          </Typography>
          <div className={classes.stats}>
            <div className={classes.border}>
              <p className={classes.verticalText}>Équipe</p>
            </div>
            <div className={classes.bar}>
              {this.renderStats(this.props.onboardingStats).map((el, i) => {
                if (i < 4) {
                  return el;
                }
              })}
            </div>
          </div>
          <div
            style={{
              backgroundColor: Colors.grey,
              height: 1,
              width: "50%"
            }}
          />
          <div className={classes.stats}>
            <div className={classes.border} style={{ backgroundColor: "#fff" }}>
              <p
                className={classes.verticalText}
                style={{ color: Colors.text }}
              >
                Process
              </p>
            </div>
            <div className={classes.bar}>
              {this.renderStats(this.props.onboardingStats).map((el, i) => {
                if (i < 9 && i >= 4) {
                  return el;
                }
              })}
            </div>
          </div>
          <div
            style={{
              backgroundColor: Colors.grey,
              height: 1,
              width: "50%"
            }}
          />
          <div className={classes.stats}>
            <div className={classes.border} style={{ backgroundColor: "red" }}>
              <p className={classes.verticalText}>Manage</p>
            </div>
            <div className={classes.bar}>
              {this.renderStats(this.props.onboardingStats).map((el, i) => {
                if (i >= 9) {
                  return el;
                }
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

{
  /* <div
                className={classes.border}
                style={{ backgroundColor: "white", height: "40%" }}
              >
                <p
                  className={classes.verticalText}
                  style={{ color: Colors.text }}
                >
                  Process
                </p>
              </div>
              <div
                className={classes.border}
                style={{ backgroundColor: "red", height: "20%" }}
              >
                <p className={classes.verticalText}>Manage</p>
              </div> */
}

Login.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { onboardingStats, requesting } = state.stats;
  return {
    clientId: state.client.clientId,
    requesting,
    onboardingStats
  };
};

export default connect(
  mapStateToProps,
  { getOnboardingStatsRequest }
)(withStyles(styles)(Login));
